import { client } from './client'

const getReferralService = async (cocap: string) => {
  const { data } = await client.get('/tracking/referrals', {
    headers: {
      cocap
    }
  })
  return data
}

export { getReferralService }
